<app-form-page [config]="config" [drillDown]="false" ></app-form-page>
<p style="margin-top: -30px; margin-left: 20px; font-weight: bold">Total Debtors Shown: {{totalCreditors | currency}}</p>

